// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___1KcC-","skeleton-loading":"styles__skeleton-loading___95q61","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___JghvE","mainSectionSkeleton":"styles__mainSectionSkeleton___sd59G","skeletonCard":"styles__skeletonCard___Lx_8x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/SharedDataSkeleton/styles.css
// module id = 2548
// module chunks = 0